import { useEffect, useRef, useContext, useState } from "react";
import React from "react";

import FuncionesContext, {
  getAtributo,
} from "../../../context/FuncionesContext";
import { useRefDataStore } from "../../../../..";

import Guardar from "../../../ABM/componentes/botonera/Guardar";
import Cancelar from "../../../ABM/componentes/botonera/Cancelar";

const sanitizeHtmlVanilla = (html) => {
  const allowedTags = new Set([
    "B",
    "I",
    "U",
    "STRONG",
    "EM",
    "P",
    "BR",
    "UL",
    "OL",
    "LI",
    "A",
    "SPAN",
    "DIV",
    "H1",
    "H2",
    "H3",
    "TABLE",
    "TD",
    "TR",
  ]);

  const allowedAttrs = new Set(["href", "target", "class", "style"]);

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const walk = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    if (!allowedTags.has(node.tagName)) {
      node.replaceWith(...Array.from(node.childNodes));
      return;
    }

    [...node.attributes].forEach((attr) => {
      if (!allowedAttrs.has(attr.name.toLowerCase())) {
        node.removeAttribute(attr.name);
      }

      if (
        attr.name.toLowerCase() === "href" &&
        attr.value.trim().toLowerCase().startsWith("javascript:")
      ) {
        node.removeAttribute(attr.name);
      }
    });

    [...node.children].forEach(walk);
  };

  [...doc.body.children].forEach(walk);

  return doc.body.innerHTML;
};

const autoResize = (el) => {
  if (!el) return;
  el.style.height = "auto";
  el.style.height = el.scrollHeight + "px";
};

export default function EditableHtmlText(props) {
  const {
    data,
    cab,
    campokey,
    context,
    id_elemento,
    valor,
    handleCancelar = () => null,
  } = props;

  const ref = useRef(null);

  const textareaRef = useRef(null);

  const { superSubmit, validarRegex } = useContext(FuncionesContext);

  const { opciones } = useContext(context);

  const [v, setStore] = useRefDataStore((s) => s[data._key + campokey]);
  const [update_id] = useRefDataStore(
    (s) => s[data._key + cab.update_id_alias]
  );

  const [value, setValue] = useState(v ?? valor);
  const [lastValue, setLastvalue] = useState(v ?? valor);
  const [isFocused, setIsFocused] = useState(false);
  const [guardado, setGuardado] = useState(true);
  const [updateId, setUpdateId] = useState(
    update_id ?? data[cab.update_id_alias]
  );

  class handleGuardar {
    static update = async () => {
      let valor = value;
      if (valor === null || lastValue?.toString() === valor.toString().trim())
        return;

      const parsedHtml = new DOMParser().parseFromString(valor, "text/html")
        .body.innerHTML;

      // 🔹 2. Sanitizar HTML (vanilla)
      valor = sanitizeHtmlVanilla(parsedHtml).trim();

      if (!validarRegex(valor, cab.validacion_regex, cab)) {
        setValue(v);
        return;
      }

      const { id_a } = cab;
      setIsFocused(false);

      superSubmit({
        valor,
        id_a,
        update_id: updateId,
        handleCancelar,
        cab,
        data,
      })
        .then((result) => {
          setLastvalue(() => valor);
          setStore({ [data._key + campokey]: valor });
          if (!updateId) {
            setStore({
              [data._key + cab.update_id_alias]: result.data.registro.id,
            });
            setUpdateId(result.data.registro.id);
          }

          setGuardado(true);
          return result;
        })
        .catch((err) => {
          console.log("Cancelado ", err);
        });
    };
  }

  /**
   * Sync valor externo → DOM
   */
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== valor) {
      ref.current.innerHTML = valor ?? "";
    }
  }, [valor]);

  useEffect(() => {
    if (isFocused && textareaRef.current) {
      autoResize(textareaRef.current);
      textareaRef.current.focus();
    }
  }, [isFocused]);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    let html = value;

    const parsed = new DOMParser().parseFromString(html, "text/html").body
      .innerHTML;

    html = sanitizeHtmlVanilla(parsed).trim();

    setValue(html);
    setIsFocused(false);
  };

  const className = getAtributo("className", data, cab);
  const isEmptyValue =
    !value ||
    value
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim() === "";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        border: guardado ? "none" : "2px solid red",
      }}
      id={id_elemento + "_container"}
      className={`${className}`}
    >
      {/* HTML editable */}
      {isFocused ? (
        <textarea
          ref={textareaRef}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            if (lastValue !== e.target.value) {
              setGuardado(false);
            }
            if (lastValue === e.target.value) {
              setGuardado(true);
            }
            autoResize(e.target)
          }}
          onBlur={handleBlur}
          style={{
            width: "100%",
            minHeight: "120px",
            fontFamily: "monospace",
            fontSize: "12px",
          }}
        />
      ) : (
        <div
          dangerouslySetInnerHTML={{
            __html: isEmptyValue ? "<span>Click para editar contenido</span>" : value,
          }}
          onClick={() => setIsFocused(true)}
          title="Click para editar contenido"
          style={{
            width: "100%",
            minHeight: "44px",
            border: isEmptyValue ? "1px dashed #9e9e9e" : "1px solid transparent",
            borderRadius: "6px",
            padding: "0.4rem",
            cursor: "pointer",
            color: isEmptyValue ? "#6f6f6f" : "inherit",
            transition: "border-color 0.15s ease, background-color 0.15s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "#1976d2";
            e.currentTarget.style.backgroundColor = "#f8fbff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = isEmptyValue
              ? "#9e9e9e"
              : "transparent";
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        />
      )}

      {/* Botonera (TU BLOQUE, intacto) */}
      {(isFocused || !guardado) && (
        <div
          style={{ width: "100%", margin: "0.2rem" }}
          className="btns-noteTaker"
        >
          <Guardar
            handleSubmit={handleGuardar.update}
            texto_confirmar="Guardar"
            size="small"
            buttonId={id_elemento + "_submit"}
            submitOnEnter={false}
          />
          <Cancelar
            size="small"
            handleCancelar={() => {
              // rollback visual
              if (ref.current) {
                ref.current.innerHTML = valor;
              }
              setIsFocused(false);
              if (typeof handleCancelar === "function") handleCancelar();
            }}
          />
        </div>
      )}
    </div>
  );
}
